import 'phaser'
import { phaserUtil } from '../engine/phaserUtil-sidecar'
import { ICargoData, ICargoType } from '../entities/cargoesData'
import { cargoesData } from '../entities/cargoesData-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { stacks } from '../entities/stacks-sidecar'
import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { fi32 } from '../main/frameInfo'
import { layers } from '../main/layers-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'

export interface IStackSelector extends IEntity {
  x: number
  y: number
  image: Phaser.GameObjects.Image
  images: Phaser.GameObjects.Image[]
  imageSelected: Phaser.GameObjects.Image
  cargoType: ICargoType | null
  isSelected: boolean
}

const objs: IStackSelector[] = []

const errorFrame = fi32(5, 0, 0)

const frameSelected = fi32(1, 6, 4)

export function create(
  x: number,
  y: number,
  cargoType: ICargoType,
  onOver: (cd: ICargoData) => void,
  onClick: (cd: ICargoData) => void,
): IStackSelector {
  let id = common.createId()

  let cd = cargoesData.getByType(cargoType)
  let frame = stacks.frame

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().ui,
    frame,
    x,
    y,
  )

  let imageSelected = spriteMap.createImageFromFrameInfo(
    layers.getLayers().ui,
    frameSelected,
    x,
    y,
  )

  let images: Phaser.GameObjects.Image[] = []

  let spread = 12
  let offsets = [
    [0, -spread],
    [-spread / 2, 0],
    [spread / 2, 0],
  ]

  for (let i = 0; i < 3; i++) {
    let image2 = spriteMap.createImageFromFrameInfo(
      layers.getLayers().ui,
      cd.frame,
      x + offsets[i][0],
      y + offsets[i][1],
    )
    images.push(image2)
  }

  let obj: IStackSelector = {
    eType: 'stack-selector',
    id,
    x,
    y,
    image,
    imageSelected,
    images,
    cargoType,
    isDead: false,
    isSelected: false,
  }
  objs.push(obj)

  phaserUtil.setInteractive(obj.image)

  obj.image.on('pointerover', () => {
    onOver(cd)
  })
  obj.image.on('pointerdown', () => {
    clickEater.tempEat()
    onClick(cd)
  })

  return obj
}

export function setVisible(obj: IStackSelector, isVisible: boolean) {
  obj.image.visible = isVisible
  obj.imageSelected.visible = isVisible && obj.isSelected
  l.forEach(obj.images, (d) => {
    d.visible = isVisible
  })
}

export function setSelected(obj: IStackSelector, isSelected: boolean) {
  obj.isSelected = isSelected
  obj.imageSelected.visible = obj.isSelected && obj.image.visible
}

export function kill(obj: IStackSelector) {
  obj.isDead = true
}
export function killAll() {
  l.forEach(objs, (c) => {
    c.isDead = true
  })
}
export function updateAll() {
  objs.forEach((c) => {
    // update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
    c.imageSelected.destroy()
    l.forEach(c.images, (d) => d.destroy())
  })
}
